import { IsochroneData } from "@/types/spatial";

/**
 * Retrieves invalid contour values from an array of IsochroneData.
 *
 * A contour is considered invalid if the feature's geometry type is not "GeometryCollection"
 * and the coordinates array is empty.
 *
 * This function traverses all features in the isochrone data, filters out the invalid ones,
 * and returns a list of contour values that are of type number.
 *
 * @param data - An array of IsochroneData to be inspected.
 * @returns An array of invalid contour values as numbers.
 */

export function getInvalidContours(data: IsochroneData[]): number[] {
  return data
    .flatMap((item) => item.data || [])
    .flatMap((collection) => collection.features || [])
    .filter(
      (feature) =>
        feature.geometry.type !== "GeometryCollection" &&
        Array.isArray(feature.geometry.coordinates) &&
        feature.geometry.coordinates.length === 0
    )
    .map((feature) => feature.properties?.contour)
    .filter((contour): contour is number => typeof contour === "number");
}
